<div fxLayout="column" fxLayoutAlign="center center" class="note-container">
  <div class="note-model-header">
    <mat-form-field>
      <textarea matInput rows="5" [formControl]="notelValue"></textarea>
    </mat-form-field>
  </div>

  <div class="button-block">
    <button
      type="button"
      class="submit-button"
      mat-raised-button
      color="accent"
      [mat-dialog-close]="notelValue.value"
      [disabled]="!notelValue?.value?.length"
    >
      {{ 'BUTTONS.SAVE' | translate }}
    </button>
  </div>
</div>
